import { render, staticRenderFns } from "./SsoVerify.vue?vue&type=template&id=bf346e92&scoped=true"
import script from "./SsoVerify.vue?vue&type=script&lang=js"
export * from "./SsoVerify.vue?vue&type=script&lang=js"
import style0 from "./SsoVerify.vue?vue&type=style&index=0&id=bf346e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf346e92",
  null
  
)

export default component.exports